import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import Draggable from 'react-draggable';
import moment from 'moment';
import throttle from 'lodash/throttle';
import Split from 'svg/split.svg';
import App from 'modules/App';
import { useCustomRanges } from 'modules/PatientResults/hooks';
import { TREND_CHART_MIN_RANGE, TREND_CHART_MAX_RANGES } from '../../constants';
import { getRoundedTimestamp, getTimestampFromX } from './helpers';
import styles from './GlucoseConcentrationTrend.pcss';
const CustomRangeSplitButton = ({ xScale, idx, tickValues, updatePhiSet })=>{
    const direction = useSelector(App.selectors.direction);
    const customRanges = useCustomRanges();
    const nodeRef = useRef(null);
    const timestamp = tickValues[idx];
    const nextTimestamp = tickValues[idx + 1];
    const getSplitTimestamp = ()=>getRoundedTimestamp(timestamp + (nextTimestamp - timestamp) / 2);
    const [splitTimestamp, setSplitTimestamp] = useState(getSplitTimestamp());
    useEffect(()=>{
        setSplitTimestamp(getSplitTimestamp());
    }, [
        tickValues
    ]);
    if (tickValues.length - 1 >= TREND_CHART_MAX_RANGES || nextTimestamp - timestamp < TREND_CHART_MIN_RANGE * 2) {
        return null;
    }
    const rawX = xScale(splitTimestamp);
    const x = rawX - 15;
    const leftTimestamp = direction === 'ltr' ? timestamp : nextTimestamp;
    const rightTimestamp = direction === 'ltr' ? nextTimestamp : timestamp;
    const minRange = direction === 'ltr' ? TREND_CHART_MIN_RANGE : -TREND_CHART_MIN_RANGE;
    const leftConstraint = xScale(leftTimestamp + minRange) - 15; // - rawX;
    const rightConstraint = xScale(rightTimestamp - minRange) - 15; // - rawX;
    const momentDate = moment.unix(splitTimestamp).utc();
    const onDragSplitBtn = (_, data)=>{
        const newTimestamp = getTimestampFromX(data.x, xScale);
        setSplitTimestamp(newTimestamp);
    };
    const onSplitCustomRange = (_, data)=>{
        const newTimestamp = getTimestampFromX(data.x, xScale);
        const newMomentDate = moment.unix(newTimestamp).utc().locale('en--account');
        const newCustomRange = [
            newMomentDate.hour(),
            newMomentDate.minutes()
        ];
        const updatedCustomRanges = [
            ...customRanges
        ];
        updatedCustomRanges.splice(idx + 1, 0, newCustomRange);
        updatePhiSet({
            customRanges: updatedCustomRanges
        });
    };
    const onDrag = throttle(onDragSplitBtn, 200);
    const onDragStop = throttle(onSplitCustomRange, 200);
    return /*#__PURE__*/ _jsx(Draggable, {
        nodeRef: nodeRef,
        axis: "x",
        bounds: {
            left: leftConstraint,
            right: rightConstraint
        },
        position: {
            x,
            y: -20
        },
        onDrag: onDrag,
        onStop: onDragStop,
        children: /*#__PURE__*/ _jsxs("g", {
            ref: nodeRef,
            className: styles.customRange__split,
            children: [
                /*#__PURE__*/ _jsx("text", {
                    className: styles.customRange__drag__valueInfo,
                    children: momentDate.format('LT')
                }),
                /*#__PURE__*/ _jsx("foreignObject", {
                    className: styles.customRange__drag__btnFObj,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.customRange__drag__btn,
                        children: /*#__PURE__*/ _jsx(Split, {
                            className: styles.customRange__label__icon
                        })
                    })
                })
            ]
        })
    });
};
export default CustomRangeSplitButton;
